import { UserWorkflow } from '../user/types'

import { IFacebookProfile } from '@/components/FacebookConnect/types'
import { IAdAccount } from '@/store/adaccounts/types'

export enum FacebookPartnerActionTypes {
  SET_FACEBOOK_PROFILE = 'SET_FACEBOOK_PROFILE',
  SET_BUSINESS_PAGES_LOADING = 'SET_BUSINESS_PAGES_LOADING',
  SET_APPLICATIONS = 'SET_APPLICATIONS',
  SET_APPLICATIONS_SENT = 'SET_APPLICATIONS_SENT',
  SET_APPLICATIONS_LOADING = 'SET_APPLICATIONS_LOADING',
  SET_SELECTED_WORKFLOW = 'SET_SELECTED_WORKFLOW',
  CLOSE_APPLICATION = 'CLOSE_APPLICATION',
}

export interface IBusinessManager {
  id: string
  name: string | null
}

export interface IBusinessInfo {
  business_type: BusinessTypes | null
  count: number | null
  selected_business_type: BusinessTypes | null
}

export interface IPartnerFacebookBusinessPage {
  id: string
  name: string | null
}

export interface IBusinessPage {
  id: string
  name: string
}

export interface IBusinessPageState {
  list: IBusinessPage[]
  isLoading: boolean
}

export interface IFacebookApplication {
  account_name: string
  website_url: string[]
  facebook_business_pages: IPartnerFacebookBusinessPage[]
  timezone: string
  facebook_app_id?: string
  email_list?: string[]
  our_business_manager?: string
  business_manager_id?: string
}

export interface IRequestBody {
  applications: IFacebookApplication[]
}

export enum ADD_FB_MODALS {
  MANAGER_TYPE_WARNING = 'managerTypeWarning',
}

export interface IAddFBModalData {
  createMyBmHandler: VoidFunction
}

export interface IModal {
  name: ADD_FB_MODALS
  data?: IAddFBModalData
}

export interface ISentFormInfo {
  isSent: boolean
  facebook_business_pages: IPartnerFacebookBusinessPage[] | []
  business_manager_id: string
}

export interface IFacebookPartnerState {
  profile: IFacebookProfile
  applications: IAdAccount[]
  sentFormInfo: ISentFormInfo
  selectedWorkflow: UserWorkflow | null
  modals: IModal | null
}

export enum BusinessTypes {
  GAMES_AND_APPLICATIONS = 'GAMES_AND_APPLICATIONS',
  OTHER = 'OTHER',
}

export enum ApplicationRequestStatuses {
  ON_REVIEW = 'ON_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PAGE_ERROR = 'PAGE_ERROR',
}

export interface SendApplicationsParams {
  body: IRequestBody
  bmType: UserWorkflow
}

export const FBModalReducerName = 'addFB.modals'
